import { render, staticRenderFns } from "./preference-widget-embed-code-step.vue?vue&type=template&id=67669aa2"
import script from "./preference-widget-embed-code-step.vue?vue&type=script&lang=js"
export * from "./preference-widget-embed-code-step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports